import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {
  driverCutOffList: {
    data: [],
    driver: null,
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    },
    exportSuccess: false
  },
  driverCutOffCount: {},
  driverCutOffDetail: {},
  reimburseReport: null,
  isDriverCutOffApproveSuccess: false,
  isDriverCutOffReimburseUpdateSuccess: false,
  withdrawRequestList: {
    data: [],
    user: null,
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    },
    exportSuccess: false
  },
  withdrawRequestCount: {},
  withdrawRequestDetail: {},
  isWithdrawRequestStatusUpdateSuccess: false,
  isWithdrawRequestUpdateToProcessingSuccess: false,
  isWithdrawRequestResponseBatchFileSuccess: false,
  isWithdrawRequestGenerateBatchFileSuccess: false,
  walletTransaction: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    },
    exportSuccess: false
  },
  walletBalance: {},
  isLoadWalletBalDone: false,
  walletTransactionCount: {},
  walletSuspendedCount: 0,
  walletAccountList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },  
  walletAccountFilterList:{
    data: [],
    total: 0,
    offset: 0,
    limit: 10,
    isLoading: false,
    hasMore: true
  },
  isProcessLoadWalletAccountFilter: false,
  isProcessLoadWalletAccountMore: false,
  walletAccountCount: {},
  isUpdateWalletVerifyStatusSuccess: false,
  isUpdateWalletVerifyStatusFail: false,
  isWalletVerifyUploadDocSuccess: false,
  isWalletVerifyUploadDocFail: false,
  isUpdateWalletAllowCreditedSuccess: false,
  isUpdateWalletAllowCreditedFail: false,
  walletResetConfirmation: null,
  driverPendingPayment: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isApproveDriverPaymentSuccess: false,
  
  isUpdateOnlineBankingPeriodSuccess: false,
  isUpdateOnlineBankingPeriodFail: false,
  bankList: [],
  bankAccountList: [],
  isCreateBankAccountSuccess: false,
  isCreateBankAccountFail: false,
  isUpdateBankAccountSuccess: false,
  isUpdateBankAccountFail: false,
  isSetBankAccountDefaultSuccess: false,
  isSetBankAccountDefaultFail: false,
  isDeleteBankAccountSuccess: false,
  isDeleteBankAccountFail: false,

  onlineBankingOrderList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    },
    exportSuccess: false
  },
  existRequestConfirmation: null,
  isProcessProcessOnlineBankingTrans: false,
  isProcessOnlineBankingTransSuccess: false,
  isProcessOnlineBankingTransFail: false,
  isProcessRollbackOnlineBankingTrans: false,
  isRollbackOnlineBankingTransSuccess: false,
  isRollbackOnlineBankingTransFail: false
};

export default function paymentReducer(state = initState, action) {

  switch (action.type) {
    case actionTypes.DRIVER_CUT_OFF_LOAD: {
      let driverCutOffList = cloneDeep(state.driverCutOffList);
      driverCutOffList.exportSuccess = false

      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        driverCutOffList.offset = action.data.offset;
        driverCutOffList.limit = action.data.limit;
      }

      driverCutOffList.driver = null
      return {
        ...state,
        driverCutOffList
      };
    }

    case actionTypes.DRIVER_CUT_OFF_LOAD_SUCCESS: {
      let driverCutOffList = cloneDeep(state.driverCutOffList);

      if(!action.data.data.export)
      {
        driverCutOffList.exportSuccess = false
        driverCutOffList.data = action.data.data;
        driverCutOffList.meta = {
          page: 1 + state.driverCutOffList.offset / state.driverCutOffList.limit,
          pageSize: state.driverCutOffList.limit,
          pageTotal: Math.ceil(
            action.data.recordsTotal / state.driverCutOffList.limit
          ),
          total: action.data.recordsTotal
        };
      }else{
        driverCutOffList.exportSuccess = true
      }
      
      driverCutOffList.driver = action.data.driver
      return {
        ...state,
        driverCutOffList
      };
    }

    case actionTypes.DRIVER_CUT_OFF_LOAD_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.DRIVER_CUT_OFF_DETAIL: {
      
      return {
        ...state,
        driverCutOffDetail: {}
      };
    }

    case actionTypes.DRIVER_CUT_OFF_DETAIL_SUCCESS: {
    
      return {
        ...state,
        driverCutOffDetail:action.data
      };
    }

    case actionTypes.DRIVER_CUT_OFF_DETAIL_FAIL: {
      return {
        ...state
      };
    }

    
    
    case actionTypes.GET_REIMBURSE_REPORT: {
      
      return {
        ...state,
        reimburseReport: null
      };
    }

    case actionTypes.GET_REIMBURSE_REPORT_SUCCESS: {
    
      return {
        ...state,
        reimburseReport:action.data
      };
    }

    case actionTypes.GET_REIMBURSE_REPORT_FAIL: {
      return {
        ...state
      };
    }
    
    
    case actionTypes.DRIVER_CUT_OFF_APPROVE: {      
      return {
        ...state,
        isDriverCutOffApproveSuccess: false
      };
    }

    case actionTypes.DRIVER_CUT_OFF_APPROVE_SUCCESS: {
      return {
        ...state,
        isDriverCutOffApproveSuccess: true
      };
    }

    case actionTypes.DRIVER_CUT_OFF_APPROVE_FAIL: {
      return {
        ...state,
        isDriverCutOffApproveSuccess: false
      };
    }

    
    case actionTypes.DRIVER_CUT_OFF_COUNT: {
      
      return {
        ...state,
        driverCutOffCount: {}
      };
    }

    case actionTypes.DRIVER_CUT_OFF_COUNT_SUCCESS: {
    
      return {
        ...state,
        driverCutOffCount:action.data
      };
    }

    case actionTypes.DRIVER_CUT_OFF_COUNT_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.DRIVER_CUT_OFF_UPDATE_REIMBURSE: {      
      return {
        ...state,
        isDriverCutOffReimburseUpdateSuccess: false
      };
    }

    case actionTypes.DRIVER_CUT_OFF_UPDATE_REIMBURSE_SUCCESS: {
      return {
        ...state,
        isDriverCutOffReimburseUpdateSuccess: true
      };
    }

    case actionTypes.DRIVER_CUT_OFF_UPDATE_REIMBURSE_FAIL: {
      return {
        ...state,
        isDriverCutOffReimburseUpdateSuccess: false
      };
    }

    /* ===== USER WITHDRAWAL  ===== */
    case actionTypes.WITHDRAW_REQUEST_LOAD: {
      let withdrawRequestList = cloneDeep(state.withdrawRequestList);
      withdrawRequestList.exportSuccess = false

      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        withdrawRequestList.offset = action.data.offset;
        withdrawRequestList.limit = action.data.limit;
      }
      withdrawRequestList.user = null

      return {
        ...state,
        withdrawRequestList
      };
    }

    case actionTypes.WITHDRAW_REQUEST_LOAD_SUCCESS: {
      let withdrawRequestList = cloneDeep(state.withdrawRequestList);
      
      if(!action.data.data.export)
      {
        withdrawRequestList.exportSuccess = false
        withdrawRequestList.data = action.data.data;
        withdrawRequestList.meta = {
          page: 1 + state.withdrawRequestList.offset / state.withdrawRequestList.limit,
          pageSize: state.withdrawRequestList.limit,
          pageTotal: Math.ceil(
            action.data.recordsTotal / state.withdrawRequestList.limit
          ),
          total: action.data.recordsTotal
        };
      }else{
        withdrawRequestList.exportSuccess = true
      }

      withdrawRequestList.user = action.data.user
      return {
        ...state,
        withdrawRequestList
      };
    }

    case actionTypes.WITHDRAW_REQUEST_LOAD_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.WITHDRAW_REQUEST_DETAIL: {
      
      return {
        ...state,
        withdrawRequestDetail: {}
      };
    }

    case actionTypes.WITHDRAW_REQUEST_DETAIL_SUCCESS: {
    
      return {
        ...state,
        withdrawRequestDetail:action.data
      };
    }

    case actionTypes.WITHDRAW_REQUEST_DETAIL_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.WITHDRAW_REQUEST_UPDATE_STATUS: {      
      return {
        ...state,
        isWithdrawRequestStatusUpdateSuccess: false
      };
    }

    case actionTypes.WITHDRAW_REQUEST_UPDATE_STATUS_SUCCESS: {
      return {
        ...state,
        isWithdrawRequestStatusUpdateSuccess: true
      };
    }

    case actionTypes.WITHDRAW_REQUEST_UPDATE_STATUS_FAIL: {
      return {
        ...state,
        isWithdrawRequestStatusUpdateSuccess: false
      };
    }

    
    case actionTypes.WITHDRAW_REQUEST_COUNT: {
      
      return {
        ...state,
        withdrawRequestCount: {}
      };
    }

    case actionTypes.WITHDRAW_REQUEST_COUNT_SUCCESS: {
    
      return {
        ...state,
        withdrawRequestCount:action.data
      };
    }

    case actionTypes.WITHDRAW_REQUEST_COUNT_FAIL: {
      return {
        ...state
      };
    }
    

    case actionTypes.WITHDRAW_REQUEST_GENERATE_WD_BATCH_FILE: {      
      return {
        ...state,
        isWithdrawRequestGenerateBatchFileSuccess: false
      };
    }

    case actionTypes.WITHDRAW_REQUEST_GENERATE_WD_BATCH_FILE_SUCCESS: {
      return {
        ...state,
        isWithdrawRequestGenerateBatchFileSuccess: true
      };
    }

    case actionTypes.WITHDRAW_REQUEST_GENERATE_WD_BATCH_FILE_FAIL: {
      return {
        ...state,
        isWithdrawRequestGenerateBatchFileSuccess: false
      };
    }
    

    case actionTypes.WITHDRAW_REQUEST_UPDATE_TO_PROCESSING: {      
      return {
        ...state,
        isWithdrawRequestUpdateToProcessingSuccess: false
      };
    }

    case actionTypes.WITHDRAW_REQUEST_UPDATE_TO_PROCESSING_SUCCESS: {
      return {
        ...state,
        isWithdrawRequestUpdateToProcessingSuccess: true
      };
    }

    case actionTypes.WITHDRAW_REQUEST_UPDATE_TO_PROCESSING_FAIL: {
      return {
        ...state,
        isWithdrawRequestUpdateToProcessingSuccess: false
      };
    }
    

    case actionTypes.WITHDRAW_REQUEST_RESPOND_BATCH_FILE: {      
      return {
        ...state,
        isWithdrawRequestResponseBatchFileSuccess: false
      };
    }

    case actionTypes.WITHDRAW_REQUEST_RESPOND_BATCH_FILE_SUCCESS: {
      return {
        ...state,
        isWithdrawRequestResponseBatchFileSuccess: true
      };
    }

    case actionTypes.WITHDRAW_REQUEST_RESPOND_BATCH_FILE_FAIL: {
      return {
        ...state,
        isWithdrawRequestResponseBatchFileSuccess: false
      };
    }

    
    
    
    /* ===== WALLET TRANSACTION ===== */
    case actionTypes.WALLET_TRANSACTION_COUNT: {
      
      return {
        ...state,
        walletTransactionCount: {}
      };
    }

    case actionTypes.WALLET_TRANSACTION_COUNT_SUCCESS: {
    
      return {
        ...state,
        walletTransactionCount:action.data
      };
    }

    case actionTypes.WALLET_TRANSACTION_COUNT_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.LOAD_WALLET_BALANCE: {
      
      return {
        ...state,
        walletBalance: {},
        isLoadWalletBalDone: false,
      };
    }

    case actionTypes.LOAD_WALLET_BALANCE_SUCCESS: {
    
      return {
        ...state,
        walletBalance:action.data,
        isLoadWalletBalDone: true,
      };
    }

    case actionTypes.LOAD_WALLET_BALANCE_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.LOAD_WALLET_TRANSACTION: {
      let walletTransaction = cloneDeep(state.walletTransaction);
      walletTransaction.exportSuccess = false

      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        walletTransaction.offset = action.data.offset;
        walletTransaction.limit = action.data.limit;
      }

      return {
        ...state,
        walletTransaction
      };
    }


    case actionTypes.LOAD_WALLET_TRANSACTION_SUCCESS: {
      let walletTransaction = cloneDeep(state.walletTransaction);

      if(!action.data.data.export)
      {
        walletTransaction.exportSuccess = false
        walletTransaction.data = action.data.data;
        walletTransaction.meta = {
          page: 1 + state.walletTransaction.offset / state.walletTransaction.limit,
          pageSize: state.walletTransaction.limit,
          pageTotal: Math.ceil(
            action.data.recordsTotal / state.walletTransaction.limit
          ),
          total: action.data.recordsTotal
        };
      }else{
        walletTransaction.exportSuccess = true
      }

      return {
        ...state,
        walletTransaction
      };
    }

    case actionTypes.LOAD_WALLET_TRANSACTION_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.LOAD_WALLET_ACCOUNT_LIST: {
      let walletAccountList = cloneDeep(state.walletAccountList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        walletAccountList.offset = action.data.offset;
        walletAccountList.limit = action.data.limit;
      }

      return {
        ...state,
        walletAccountList,
        walletSuspendedCount: 0
      };
    }


    case actionTypes.LOAD_WALLET_ACCOUNT_LIST_SUCCESS: {
      let walletAccountList = cloneDeep(state.walletAccountList);
      walletAccountList.data = action.data.data;
      walletAccountList.meta = {
        page: 1 + state.walletAccountList.offset / state.walletAccountList.limit,
        pageSize: state.walletAccountList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.walletAccountList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        walletAccountList,
        walletSuspendedCount: action.data.totalSuspended
      };
    }

    case actionTypes.LOAD_WALLET_ACCOUNT_LIST_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.LOAD_WALLET_ACCOUNT_FILTER: {
      
      let walletAccountFilterList = cloneDeep(state.walletAccountFilterList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        walletAccountFilterList.offset = action.data.offset;
        walletAccountFilterList.limit = action.data.limit;
      }

      walletAccountFilterList.isLoading = true;
      
      if (action.data.offset === 0) 
        walletAccountFilterList.data = [];

      return {
        ...state,
        walletAccountFilterList,
        isProcessLoadWalletAccountFilter: (action.data.offset === 0) ? true : false,
        isProcessLoadWalletAccountMore: (action.data.offset === 0) ? false : true,
      };
    }

    case actionTypes.LOAD_WALLET_ACCOUNT_FILTER_SUCCESS: {
      
      let walletAccountFilterList = cloneDeep(state.walletAccountFilterList);
      
      if(action.data.data.length > 0)
      {
        walletAccountFilterList.data = [...walletAccountFilterList.data, ...action.data.data];        
        walletAccountFilterList.hasMore = (action.data.data.length < state.walletAccountFilterList.limit) ? false : true;
      }else
      walletAccountFilterList.hasMore = false;

      walletAccountFilterList.isLoading = false;

      return {
        ...state,
        walletAccountFilterList,
        isProcessLoadWalletAccountFilter: false,
        isProcessLoadWalletAccountMore: false,
      };
    }

    case actionTypes.LOAD_WALLET_ACCOUNT_FILTER_FAIL: {
      
      let walletAccountFilterList = cloneDeep(state.walletAccountFilterList);
      walletAccountFilterList.isLoading = false;
      walletAccountFilterList.hasMore = false;

      return {
        ...state,
        walletAccountFilterList,
        isProcessLoadWalletAccountFilter: false,
        isProcessLoadWalletAccountMore: false,
      };
    }
    
    
    case actionTypes.LOAD_WALLET_ACCOUNT_COUNT: {
      
      return {
        ...state,
        walletAccountCount: {}
      };
    }

    case actionTypes.LOAD_WALLET_ACCOUNT_COUNT_SUCCESS: {
    
      return {
        ...state,
        walletAccountCount:action.data
      };
    }

    case actionTypes.LOAD_WALLET_ACCOUNT_COUNT_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.UPDATE_WALLET_VERIFY_STATUS: {
      return {
        ...state,
        isUpdateWalletVerifyStatusSuccess: false,
        isUpdateWalletVerifyStatusFail: false
      };
    }

    case actionTypes.UPDATE_WALLET_VERIFY_STATUS_SUCCESS: {
      return {
        ...state,
        isUpdateWalletVerifyStatusSuccess: true
      };
    }

    case actionTypes.UPDATE_WALLET_VERIFY_STATUS_FAIL: {
      return {
        ...state,
        isUpdateWalletVerifyStatusFail: true
      };
    }

    case actionTypes.WALLET_VERIFY_UPLOAD_DOC: {
      return {
        ...state,
        isWalletVerifyUploadDocSuccess: false,
        isWalletVerifyUploadDocFail: false
      };
    }

    case actionTypes.WALLET_VERIFY_UPLOAD_DOC_SUCCESS: {
      return {
        ...state,
        isWalletVerifyUploadDocSuccess: true
      };
    }

    case actionTypes.WALLET_VERIFY_UPLOAD_DOC_FAIL: {
      return {
        ...state,
        isWalletVerifyUploadDocFail: true
      };
    }
    
    case actionTypes.UPDATE_WALLET_ALLOW_CREDITED: {
      return {
        ...state,
        isUpdateWalletAllowCreditedSuccess: false,
        isUpdateWalletAllowCreditedFail: false,
        walletResetConfirmation: null,
      };
    }

    case actionTypes.UPDATE_WALLET_ALLOW_CREDITED_SUCCESS: {
      return {
        ...state,
        isUpdateWalletAllowCreditedSuccess: (action.data) ? false : true,
        walletResetConfirmation: (action.data && action.data.reset_confirmed) ? action.data : null,
      };
    }

    case actionTypes.UPDATE_WALLET_ALLOW_CREDITED_FAIL: {
      return {
        ...state,
        isUpdateWalletAllowCreditedFail: true
      };
    }
    
    case actionTypes.UPDATE_ONLINE_BANKING_PERIOD: {
      return {
        ...state,
        isUpdateOnlineBankingPeriodSuccess: false,
        isUpdateOnlineBankingPeriodFail: false,
      };
    }

    case actionTypes.UPDATE_ONLINE_BANKING_PERIOD_SUCCESS: {
      return {
        ...state,
        isUpdateOnlineBankingPeriodSuccess: true,
      };
    }

    case actionTypes.UPDATE_ONLINE_BANKING_PERIOD_FAIL: {
      return {
        ...state,
        isUpdateOnlineBankingPeriodFail: true
      };
    }
    
    
    case actionTypes.LOAD_BANK_LIST: {
      
      return {
        ...state,
        bankList: []
      };
    }

    case actionTypes.LOAD_BANK_LIST_SUCCESS: {
    
      return {
        ...state,
        bankList:action.data
      };
    }

    case actionTypes.LOAD_BANK_LIST_FAIL: {
      return {
        ...state
      };
    }
    case actionTypes.LOAD_BANK_ACCOUNT_LIST: {
      
      return {
        ...state,
        bankAccountList: []
      };
    }

    case actionTypes.LOAD_BANK_ACCOUNT_LIST_SUCCESS: {
    
      return {
        ...state,
        bankAccountList:action.data
      };
    }

    case actionTypes.LOAD_BANK_ACCOUNT_LIST_FAIL: {
      return {
        ...state
      };
    }
    
    case actionTypes.CREATE_BANK_ACCOUNT: {
      return {
        ...state,
        isCreateBankAccountSuccess: false,
        isCreateBankAccountFail: false,
      };
    }

    case actionTypes.CREATE_BANK_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isCreateBankAccountSuccess: true,
      };
    }

    case actionTypes.CREATE_BANK_ACCOUNT_FAIL: {
      return {
        ...state,
        isCreateBankAccountFail: true
      };
    }
    
    case actionTypes.UPDATE_BANK_ACCOUNT: {
      return {
        ...state,
        isUpdateBankAccountSuccess: false,
        isUpdateBankAccountFail: false,
      };
    }

    case actionTypes.UPDATE_BANK_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isUpdateBankAccountSuccess: true,
      };
    }

    case actionTypes.UPDATE_BANK_ACCOUNT_FAIL: {
      return {
        ...state,
        isUpdateBankAccountFail: true
      };
    }
    
    case actionTypes.SET_BANK_ACCOUNT_DEFAULT: {
      return {
        ...state,
        isSetBankAccountDefaultSuccess: false,
        isSetBankAccountDefaultFail: false,
      };
    }

    case actionTypes.SET_BANK_ACCOUNT_DEFAULT_SUCCESS: {
      return {
        ...state,
        isSetBankAccountDefaultSuccess: true,
      };
    }

    case actionTypes.SET_BANK_ACCOUNT_DEFAULT_FAIL: {
      return {
        ...state,
        isSetBankAccountDefaultFail: true
      };
    }
    
    case actionTypes.DELETE_BANK_ACCOUNT: {
      return {
        ...state,
        isDeleteBankAccountSuccess: false,
        isDeleteBankAccountFail: false,
      };
    }

    case actionTypes.DELETE_BANK_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isDeleteBankAccountSuccess: true,
      };
    }

    case actionTypes.DELETE_BANK_ACCOUNT_FAIL: {
      return {
        ...state,
        isDeleteBankAccountFail: true
      };
    }
    
    /* ===== END WALLET TRANSACTION ===== */

    /* ===== DRIVER PENDING PAYMENT ===== */

    case actionTypes.LOAD_DRIVER_PENDING_PAYMENT: {
      let driverPendingPayment = cloneDeep(state.driverPendingPayment);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        driverPendingPayment.offset = action.data.offset;
        driverPendingPayment.limit = action.data.limit;
      }

      return {
        ...state,
        driverPendingPayment
      };
    }


    case actionTypes.LOAD_DRIVER_PENDING_PAYMENT_SUCCESS: {
      let driverPendingPayment = cloneDeep(state.driverPendingPayment);
      driverPendingPayment.data = action.data.data;
      driverPendingPayment.meta = {
        page: 1 + state.driverPendingPayment.offset / state.driverPendingPayment.limit,
        pageSize: state.driverPendingPayment.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.driverPendingPayment.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        driverPendingPayment
      };
    }

    case actionTypes.LOAD_DRIVER_PENDING_PAYMENT_FAIL: {
      return {
        ...state
      };
    }


    case actionTypes.APPROVE_DRIVER_PAYMENT: {
      return {
        ...state,
        isApproveDriverPaymentSuccess: false
      };
    }

    case actionTypes.APPROVE_DRIVER_PAYMENT_SUCCESS: {
      return {
        ...state,
        isApproveDriverPaymentSuccess: true
      };
    }

    case actionTypes.APPROVE_DRIVER_PAYMENT_FAIL: {
      return {
        ...state,
        isApproveDriverPaymentSuccess: false
      };
    }
    /* ===== END DRIVER PENDING PAYMENT ===== */

    /* ===== ONLINE BANKING ORDER ===== */

    case actionTypes.LOAD_ONLINE_BANKING_ORDER_LIST: {
      let onlineBankingOrderList = cloneDeep(state.onlineBankingOrderList);
      onlineBankingOrderList.exportSuccess = false

      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        onlineBankingOrderList.offset = action.data.offset;
        onlineBankingOrderList.limit = action.data.limit;
      }

      if (action.data.offset === 0 && !action.data.exportFile) 
        onlineBankingOrderList.data = [];

      return {
        ...state,
        onlineBankingOrderList
      };
    }


    case actionTypes.LOAD_ONLINE_BANKING_ORDER_LIST_SUCCESS: {
      let onlineBankingOrderList = cloneDeep(state.onlineBankingOrderList);
      if(!action.data.data.export)
      {
        onlineBankingOrderList.exportSuccess = false
        onlineBankingOrderList.data = action.data.data;
        onlineBankingOrderList.meta = {
          page: 1 + state.onlineBankingOrderList.offset / state.onlineBankingOrderList.limit,
          pageSize: state.onlineBankingOrderList.limit,
          pageTotal: Math.ceil(
            action.data.recordsTotal / state.onlineBankingOrderList.limit
          ),
          total: action.data.recordsTotal
        };
      }else{
        onlineBankingOrderList.exportSuccess = true
      }

      return {
        ...state,
        onlineBankingOrderList
      };
    }

    case actionTypes.LOAD_ONLINE_BANKING_ORDER_LIST_FAIL: {
      return {
        ...state
      };
    }


    case actionTypes.PROCES_ONLINE_BANKING_TRANS: {
      return {
        ...state,
        isProcessOnlineBankingTransSuccess: false,
        isProcessOnlineBankingTransFail: false,
        isProcessProcessOnlineBankingTrans: true,
      };
    }

    case actionTypes.PROCES_ONLINE_BANKING_TRANS_SUCCESS: {
      return {
        ...state,
        isProcessOnlineBankingTransSuccess: (action.data && action.data.exist_request) ? false : true,
        existRequestConfirmation: (action.data && action.data.exist_request) ? action.data : null,
        isProcessProcessOnlineBankingTrans: false,
      };
    }

    case actionTypes.PROCES_ONLINE_BANKING_TRANS_FAIL: {
      return {
        ...state,
        isProcessOnlineBankingTransFail: true,
        isProcessProcessOnlineBankingTrans: false,
      };
    }


    case actionTypes.ROLLBACK_ONLINE_BANKING_TRANS: {
      return {
        ...state,
        isRollbackOnlineBankingTransSuccess: false,
        isRollbackOnlineBankingTransFail: false,
        isProcessRollbackOnlineBankingTrans: true,
      };
    }

    case actionTypes.ROLLBACK_ONLINE_BANKING_TRANS_SUCCESS: {
      return {
        ...state,
        isRollbackOnlineBankingTransSuccess: true,
        isProcessRollbackOnlineBankingTrans: false,
      };
    }

    case actionTypes.ROLLBACK_ONLINE_BANKING_TRANS_FAIL: {
      return {
        ...state,
        isRollbackOnlineBankingTransFail: true,
        isProcessRollbackOnlineBankingTrans: false,
      };
    }
    /* ===== END ONLINE BANKING ORDER ===== */


    default:
      return state;
  }
}
